import { $myFetch } from "."
import { toastr } from "react-redux-toastr"
import { stringify } from "../../utils/stringifyier"

export const $getMaintenanceState = () => {
  const myHeaders = new Headers()
  return $myFetch(`maintenance/GetMaintenanceState`, {
    headers: myHeaders,
  }).then((res) => res.json())
}

// Errors are displayed by $myFetch: only the success needs a message here.
export const $activateMaintenance = () =>
  $setMaintenanceState(true)
    .then((res) => {
      toastr.success("Opération réussie", "Dropit est maintenant en maintenance")
      return res
    })
    .catch(() => undefined)

export const $deactivateMaintenance = () =>
  $setMaintenanceState(false)
    .then((res) => {
      toastr.success(
        "Opération réussie",
        "Dropit est maintenant en fonctionnement normal"
      )
      return res
    })
    .catch(() => undefined)

const $setMaintenanceState = (bool: boolean) => {
  const myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json")
  return $myFetch(`maintenance/SetMaintenanceState`, {
    headers: myHeaders,
    method: "POST",
    body: stringify({ state: bool }),
  })
}